import { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Badge } from "../../components/ui/badge";
import { Dialog, DialogContent, DialogTitle } from "../../components/ui/dialog";
import { FileSpreadsheet, Sparkles, Download, Loader2, Trash2, X, UploadCloud, ChevronLeft, ChevronRight, CheckCircle2, FileCheck2, Eye, Plus, Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SECCIONES = [
  { key: "trp", label: "Todo Riesgo Propiedades", ramo: true },
  { key: "rc", label: "Responsabilidad Civil", ramo: true },
  { key: "fidelidad", label: "Fidelidad 3D", ramo: true },
  { key: "coaseguro", label: "Distribución Coaseguro" },
  { key: "licitacion", label: "Cuadro de Licitación" },
  { key: "comparativo", label: "Comparativo de Primas" },
  { key: "siniestralidad", label: "Siniestralidad (se digita manual)" },
  { key: "productos", label: "Productos adicionales sugeridos" },
];

const PASOS = ["Excel", "Datos", "Secciones", "Contactos", "Endosos", "Textos IA", "Generar"];

const ENDOSOS_DEFAULT = {
  trp: [],
  rc: [
    { titulo: "RC de Parqueos Incluyendo Robo y Colisión:", contenido: "Se extiende a cubrir dentro de la vigencia de la póliza, la Responsabilidad Civil imputable al asegurado como consecuencia directa de daños materiales, incluyendo Robo, causados a vehículos de terceros, estacionados dentro de los predios asegurados.\n\n\"Esta cobertura se otorga única y exclusivamente en parqueos cerrados con control de entrada y salida, servicio de vigilancia permanente y sistema de cámara de seguridad, siempre y cuando las pérdidas o daños sean causados a consecuencia de:\n\nPredio asegurado Daños ocasionados a consecuencia de un evento accidental, súbito e imprevisto, que se produzcan en las instalaciones del asegurado y por el cual resulte legalmente responsable.\n\nRobo Incluyendo sus partes y accesorios.\n\nColisión y Choque Daños por colisión/Choque ocasionados dentro de los predios por terceros que se den a la fuga y se impute la responsabilidad al asegurado." },
    { titulo: "RC Valet Parking:", contenido: "La Póliza se extiende a cubrir la Responsabilidad Civil del asegurado por daños causados a los vehículos que le son confiados para Servicio de Valet Parking incluyendo la Colisión, Vuelco, Incendio y Robo de dichos vehículos de terceros.\nSublimite asegurado: USD 10,000\n\nEs condición que el asegurado cumpla lo siguiente:\nLa cobertura de Valet Parking aplica siempre que el aparcamiento se realice en un espacio destinado al aparcamiento de vehículos, excluye los vehículos aparcados en las calles o sobre la acera\nEstablecer control y Verificación de los Vehículos 3. Vigilancia permanente durante las horas de servicios\n\nDeducibles\nRobo: 5% de la Pérdida Mínimo USD 400\nColisión y Vuelvo: 2% de la Pérdida Mínimo USD 400" },
  ],
  fidelidad: [
    { titulo: "Pérdida dinero valores funcionarios hasta USD 1,000", contenido: "Hacer constar que las Cobertura de transporte de efectivo está sujeta a que se realice según las siguientes condiciones:\n\nForma de transporte monto máximo a cubrir\n\nCualquier medio de transporte que no sea cerrado USD 6,000.00\nEn medio de transporte cerrado y dentro de la cabina USD 15,000.00\nEn medio de transporte cerrado con 2 personas o custodios autorizadas por el asegurado USD 55,000\n\nCobertura dentro del local, se extiende el límite temporal para cubrir el efectivo por las operaciones de las últimas 48 horas excepto para fines de semana largos que seria 72 horas" },
  ],
};

const SECCIONES_ENDOSOS = [
  { key: "trp", label: "Todo Riesgo Propiedades" },
  { key: "rc", label: "Responsabilidad Civil" },
  { key: "fidelidad", label: "Fidelidad 3D" },
];

const GRUPOS_DEFAULT = [
  { titulo: "Emisión, Renovación y mantenimiento de las pólizas", contactos: [
    { nombre: "JianCarlos Gúzman", posicion: "Ejecutivo Senior Riesgos Generales", telefono: "809-701-6833 Ext. 2238", movil: "809-910-4222", correo: "jiancarlos_guzman@qasesores.com.do" },
    { nombre: "Ramona Guaba", posicion: "Gerente Operaciones", telefono: "809-701-6833 Ext. 2282", movil: "809-754-5514", correo: "rguaba@qasesores.com.do" },
    { nombre: "Ondina Fiallo", posicion: "Director Técnico", telefono: "809-701-6833 Ext. 2246", movil: "809-740-7493", correo: "ofiallo@qasesores.com.do" },
  ]},
  { titulo: "Asistencia técnica y comercial", contactos: [
    { nombre: "Luis Mejía", posicion: "Gerente Negocios", telefono: "809-701-6833 Ext. 2277", movil: "849-505-1252", correo: "lmejia@qasesores.com.do" },
  ]},
  { titulo: "Reclamaciones", contactos: [
    { nombre: "Gabriel Morillo", posicion: "Coordinador Reclamos Auto", telefono: "809-701-6833 Ext. 2223", movil: "829-470-7491", correo: "gmorillo@qasesores.com.do" },
    { nombre: "Raúl Valdez", posicion: "Coordinador Reclamos Propiedad", telefono: "809-701-6833 Ext. 2274", movil: "(809) 754-9647", correo: "rvaldez@qasesores.com.do" },
    { nombre: "Anabel Segura", posicion: "Director Reclamaciones", telefono: "809-701-6833 Ext. 2222", movil: "829-470-4105", correo: "asegura@qasesores.com.do" },
  ]},
  { titulo: "Coordinación de pagos", contactos: [
    { nombre: "Lucarlis Travieso", posicion: "Ejecutivo de Cobros", telefono: "809-701-6833 Ext. 2225", movil: "829-470-4100", correo: "rosa-cruz@qasesores.com.do" },
    { nombre: "Rosa Berroa", posicion: "Gerente de Cobros", telefono: "809-701-6833 Ext. 2284", movil: "849-505-1253", correo: "rberroa@qasesores.com.do" },
  ]},
  { titulo: "Socio", contactos: [
    { nombre: "Ramon Omar Alma", posicion: "Socio Director", telefono: "809-701-6833 Ext. 2250", movil: "829-224-7808", correo: "ralma@qasesores.com.do" },
  ]},
];

function ContactoSelect({ value, directorio, onChange, onSelect, testId }) {
  const [abierto, setAbierto] = useState(false);
  const filtro = (value || "").toLowerCase();
  const opciones = directorio.filter(d => d.nombre.toLowerCase().includes(filtro)).slice(0, 8);
  return (
    <div className="relative">
      <Input
        value={value}
        onChange={e => { onChange(e.target.value); setAbierto(true); }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setTimeout(() => setAbierto(false), 180)}
        placeholder="Buscar persona..."
        data-testid={testId}
      />
      {abierto && opciones.length > 0 && (
        <div className="absolute z-30 mt-1 w-72 max-h-52 overflow-y-auto bg-white border rounded-lg shadow-lg" data-testid={`${testId}-lista`}>
          {opciones.map((d, i) => (
            <button
              key={`${d.nombre}-${i}`}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); onSelect(d); setAbierto(false); }}
              className="w-full text-left px-3 py-2 hover:bg-emerald-50 border-b last:border-0"
              data-testid={`${testId}-opcion-${i}`}
            >
              <p className="text-sm text-slate-800">{d.nombre}</p>
              <p className="text-[11px] text-slate-400">{d.posicion || d.correo}{d.origen === "usuario" ? " · usuario plataforma" : ""}</p>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default function RenovacionWizard() {
  const [paso, setPaso] = useState(0);
  const [subiendo, setSubiendo] = useState(false);
  const [borrador, setBorrador] = useState(null);
  const [form, setForm] = useState({ cliente: "", anio: String(new Date().getFullYear()), periodo_vig: "", periodo_ren: "", moneda: "" });
  const [logo, setLogo] = useState(null);
  const [coaseguro, setCoaseguro] = useState([{ pct: "60", nombre: "Líder" }, { pct: "20", nombre: "" }, { pct: "20", nombre: "" }]);
  const [incluye, setIncluye] = useState({ trp: true, rc: true, fidelidad: true, coaseguro: true, licitacion: true, comparativo: true, siniestralidad: false, productos: true });
  const [sini, setSini] = useState({ total: "", pct: "", moneda: "Todo en Pesos Dominicanos" });
  const [textos, setTextos] = useState({ que_hemos_hecho: "", que_hemos_logrado: "", observaciones: "" });
  const [grupos, setGrupos] = useState(() => JSON.parse(JSON.stringify(GRUPOS_DEFAULT)));
  const [endosos, setEndosos] = useState(() => JSON.parse(JSON.stringify(ENDOSOS_DEFAULT)));
  const [regenerando, setRegenerando] = useState(false);
  const [directorio, setDirectorio] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [previewIdx, setPreviewIdx] = useState(null);
  const [cargandoPreviews, setCargandoPreviews] = useState(false);
  const [borradoresGuardados, setBorradoresGuardados] = useState([]);
  const [guardandoBorrador, setGuardandoBorrador] = useState(false);
  const [generandoTextos, setGenerandoTextos] = useState(false);
  const [generando, setGenerando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [historial, setHistorial] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const excelRef = useRef(null);
  const logoRef = useRef(null);

  const auth = useCallback(() => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }), []);

  const fetchHistorial = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/presentaciones-renovacion/historial`, auth());
      setHistorial(res.data?.items || []);
    } catch { /* silencioso */ }
  }, [auth]);

  const fetchBorradores = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/presentaciones-renovacion/borradores-guardados`, auth());
      setBorradoresGuardados(res.data?.items || []);
    } catch { /* silencioso */ }
  }, [auth]);

  useEffect(() => { fetchHistorial(); fetchBorradores(); }, [fetchHistorial, fetchBorradores]);

  const guardarBorrador = async () => {
    if (!borrador) return;
    try {
      setGuardandoBorrador(true);
      const fd = new FormData();
      fd.append("config", JSON.stringify({ form, incluye, coaseguro, sini, textos, grupos, endosos }));
      fd.append("paso", String(paso));
      if (logo) fd.append("logo_cliente", logo);
      await axios.put(`${API}/presentaciones-renovacion/${borrador.id}/guardar-borrador`, fd, {
        headers: { ...auth().headers, "Content-Type": "multipart/form-data" },
      });
      toast.success("Borrador guardado — puedes retomarlo cuando quieras");
      fetchBorradores();
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo guardar el borrador");
    } finally {
      setGuardandoBorrador(false);
    }
  };

  const retomarBorrador = async (id) => {
    try {
      const res = await axios.get(`${API}/presentaciones-renovacion/${id}/borrador-detalle`, auth());
      const d = res.data;
      setBorrador({ id: d.borrador_id, resumen: d.resumen, archivo: d.archivo });
      const cw = d.config_wizard || {};
      if (cw.form) setForm(f => ({ ...f, ...cw.form }));
      if (cw.incluye) setIncluye(i => ({ ...i, ...cw.incluye }));
      if (Array.isArray(cw.coaseguro) && cw.coaseguro.length) setCoaseguro(cw.coaseguro);
      if (cw.sini) setSini(s => ({ ...s, ...cw.sini }));
      if (cw.textos) setTextos(t => ({ ...t, ...cw.textos }));
      if (Array.isArray(cw.grupos) && cw.grupos.length) setGrupos(cw.grupos);
      if (cw.endosos) setEndosos(e => ({ ...e, ...cw.endosos }));
      setResultado(null);
      setPaso(typeof d.paso === "number" ? Math.min(d.paso, PASOS.length - 1) : 0);
      toast.success("Borrador retomado — continúa donde lo dejaste");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo retomar el borrador");
    }
  };

  const eliminarBorrador = async (id) => {
    if (!window.confirm("¿Eliminar este borrador guardado?")) return;
    try {
      await axios.delete(`${API}/presentaciones-renovacion/borradores-guardados/${id}`, auth());
      toast.success("Borrador eliminado");
      fetchBorradores();
    } catch {
      toast.error("No se pudo eliminar el borrador");
    }
  };

  useEffect(() => {
    axios.get(`${API}/presentaciones-renovacion/contactos-directorio`, auth())
      .then(res => setDirectorio(res.data?.items || []))
      .catch(() => {});
  }, [auth]);

  const setContacto = (gi, ci, campo, valor) => {
    setGrupos(gs => gs.map((g, i) => i !== gi ? g : {
      ...g, contactos: g.contactos.map((c, j) => j !== ci ? c : { ...c, [campo]: valor })
    }));
  };

  const seleccionarContacto = (gi, ci, d) => {
    setGrupos(gs => gs.map((g, i) => i !== gi ? g : {
      ...g, contactos: g.contactos.map((c, j) => j !== ci ? c : {
        nombre: d.nombre, posicion: d.posicion || c.posicion, telefono: d.telefono || c.telefono,
        movil: d.movil || c.movil, correo: d.correo || c.correo,
      })
    }));
    toast.success(`Datos de ${d.nombre} cargados del directorio`);
  };

  const loadPreviews = useCallback(async (id, count) => {
    setPreviews(prev => { prev.forEach(u => URL.revokeObjectURL(u)); return []; });
    if (!id || !count) return;
    try {
      setCargandoPreviews(true);
      const urls = await Promise.all(
        Array.from({ length: count }, (_, i) =>
          axios.get(`${API}/presentaciones-renovacion/${id}/preview/${i}`, { ...auth(), responseType: "blob" })
            .then(r => URL.createObjectURL(r.data))
        )
      );
      setPreviews(urls);
    } catch { /* silencioso */ } finally {
      setCargandoPreviews(false);
    }
  }, [auth]);

  const anio = parseInt(form.anio, 10) || new Date().getFullYear();

  const subirExcel = async (file) => {
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".xlsx") && !file.name.toLowerCase().endsWith(".xlsm")) {
      toast.error("El cuadro comparativo debe ser un Excel (.xlsx)");
      return;
    }
    try {
      setSubiendo(true);
      const fd = new FormData();
      fd.append("file", file);
      const res = await axios.post(`${API}/presentaciones-renovacion/analizar-excel`, fd, {
        headers: { ...auth().headers, "Content-Type": "multipart/form-data" }, timeout: 120000,
      });
      const r = res.data.resumen;
      setBorrador({ id: res.data.borrador_id, resumen: r, archivo: file.name });
      setForm(f => ({
        ...f,
        cliente: r.cliente || f.cliente,
        moneda: r.moneda || f.moneda,
        periodo_vig: `${anio - 1} / ${anio}`,
        periodo_ren: `${anio} / ${anio + 1}`,
      }));
      setIncluye(inc => ({
        ...inc,
        trp: r.ramos?.trp ?? false, rc: r.ramos?.rc ?? false, fidelidad: r.ramos?.fidelidad ?? false,
        licitacion: r.tiene_licitacion, comparativo: r.tiene_comparativo,
      }));
      if (r.observaciones_excel?.length) setTextos(t => ({ ...t, observaciones: r.observaciones_excel.join("\n\n") }));
      toast.success("Excel analizado correctamente");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo analizar el Excel");
    } finally {
      setSubiendo(false);
    }
  };

  const generarTextosIA = async () => {
    if (!borrador) return;
    try {
      setGenerandoTextos(true);
      const res = await axios.post(`${API}/presentaciones-renovacion/${borrador.id}/textos-ia`, {}, { ...auth(), timeout: 120000 });
      setTextos(t => ({
        que_hemos_hecho: res.data.textos.que_hemos_hecho || t.que_hemos_hecho,
        que_hemos_logrado: res.data.textos.que_hemos_logrado || t.que_hemos_logrado,
        observaciones: res.data.textos.observaciones || t.observaciones,
      }));
      toast.success("Textos propuestos por la IA — edítalos a tu gusto");
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudieron generar los textos");
    } finally {
      setGenerandoTextos(false);
    }
  };

  const buildConfig = () => ({
    cliente: form.cliente, anio: form.anio, moneda: form.moneda,
    periodo_vig: form.periodo_vig, periodo_ren: form.periodo_ren,
    incluye,
    coaseguro: incluye.coaseguro ? coaseguro.filter(c => c.pct).map(c => ({ pct: c.pct, nombre: c.nombre })) : [],
    siniestralidad: incluye.siniestralidad ? { total: parseFloat(sini.total) || 0, pct: sini.pct, moneda: sini.moneda } : null,
    textos,
    contactos: grupos
      .map(g => ({ titulo: g.titulo, contactos: g.contactos.filter(c => (c.nombre || "").trim()) }))
      .filter(g => g.titulo.trim() && g.contactos.length),
    endosos: {
      trp: endosos.trp.filter(e => (e.titulo || "").trim() || (e.contenido || "").trim()),
      rc: endosos.rc.filter(e => (e.titulo || "").trim() || (e.contenido || "").trim()),
      fidelidad: endosos.fidelidad.filter(e => (e.titulo || "").trim() || (e.contenido || "").trim()),
    },
  });

  const generarPPT = async () => {
    if (!borrador) return;
    try {
      setGenerando(true);
      setResultado(null);
      const fd = new FormData();
      fd.append("config", JSON.stringify(buildConfig()));
      if (logo) fd.append("logo_cliente", logo);
      const res = await axios.post(`${API}/presentaciones-renovacion/${borrador.id}/generar`, fd, {
        headers: { ...auth().headers, "Content-Type": "multipart/form-data" }, timeout: 300000,
      });
      setResultado(res.data);
      toast.success("¡Presentación de renovación generada!");
      fetchHistorial();
      loadPreviews(res.data.id, res.data.num_previews);
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo generar la presentación");
    } finally {
      setGenerando(false);
    }
  };

  const regenerarPPT = async (mantenerIdx = null) => {
    if (!resultado?.id) return;
    try {
      setRegenerando(true);
      const fd = new FormData();
      fd.append("config", JSON.stringify(buildConfig()));
      if (logo) fd.append("logo_cliente", logo);
      const res = await axios.post(`${API}/presentaciones-renovacion/${resultado.id}/regenerar`, fd, {
        headers: { ...auth().headers, "Content-Type": "multipart/form-data" }, timeout: 300000,
      });
      setResultado(res.data);
      toast.success("Presentación regenerada con los cambios actuales");
      fetchHistorial();
      await loadPreviews(res.data.id, res.data.num_previews);
      if (mantenerIdx !== null) setPreviewIdx(Math.min(mantenerIdx, (res.data.num_previews || 1) - 1));
    } catch (err) {
      toast.error(err.response?.data?.detail || "No se pudo regenerar la presentación");
    } finally {
      setRegenerando(false);
    }
  };

  const descargar = async (id, nombre) => {
    try {
      const res = await axios.get(`${API}/presentaciones-renovacion/${id}/descargar`, { ...auth(), responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = nombre || "renovacion.pptx";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("No se pudo descargar el archivo");
    }
  };

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta presentación del historial?")) return;
    try {
      await axios.delete(`${API}/presentaciones-renovacion/${id}`, auth());
      toast.success("Eliminada");
      fetchHistorial();
    } catch {
      toast.error("No se pudo eliminar");
    }
  };

  const fmt = (v) => (v == null ? "-" : Number(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  const r = borrador?.resumen;

  return (
    <div className="space-y-6" data-testid="renovacion-wizard">
      {/* Stepper */}
      <div className="flex items-center gap-1 flex-wrap">
        {PASOS.map((p, i) => (
          <button
            key={p}
            type="button"
            disabled={!borrador && i > 0}
            onClick={() => setPaso(i)}
            className={`flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-colors ${i === paso ? "bg-emerald-600 text-white" : i < paso || (borrador && i > 0) ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-200" : "bg-slate-100 text-slate-400"}`}
            data-testid={`renov-paso-${i}`}
          >
            <span className={`w-4 h-4 rounded-full text-[10px] flex items-center justify-center ${i === paso ? "bg-white text-emerald-700" : "bg-emerald-600/20"}`}>{i + 1}</span>
            {p}
          </button>
        ))}
      </div>

      <Card>
        <CardContent className="pt-5 space-y-4">
          {/* PASO 1: Excel */}
          {paso === 0 && (
            <div className="space-y-4">
              {!borrador ? (
                <div
                  onClick={() => excelRef.current?.click()}
                  onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                  onDragLeave={() => setDragOver(false)}
                  onDrop={(e) => { e.preventDefault(); setDragOver(false); subirExcel(e.dataTransfer?.files?.[0]); }}
                  className={`border-2 border-dashed rounded-xl px-6 py-12 text-center cursor-pointer transition-colors ${dragOver ? "border-emerald-500 bg-emerald-50" : "border-slate-300 hover:border-emerald-400 hover:bg-slate-50"}`}
                  data-testid="renov-excel-dropzone"
                >
                  {subiendo ? (
                    <><Loader2 className="w-8 h-8 mx-auto mb-2 text-emerald-600 animate-spin" /><p className="text-sm text-slate-600">Analizando el cuadro comparativo...</p></>
                  ) : (
                    <>
                      <FileSpreadsheet className="w-9 h-9 mx-auto mb-2 text-emerald-600" />
                      <p className="text-sm font-semibold text-slate-700">Arrastra aquí el Excel del cuadro comparativo</p>
                      <p className="text-xs text-slate-400 mt-1">Hojas esperadas: Comparativo Renovación, Licitación, Cond. por ramo, Fidelidad, Desglose</p>
                    </>
                  )}
                  <input ref={excelRef} type="file" accept=".xlsx,.xlsm" className="hidden" onChange={(e) => { subirExcel(e.target.files?.[0]); e.target.value = ""; }} data-testid="renov-excel-input" />
                </div>
              ) : (                <div className="space-y-3" data-testid="renov-resumen-excel">
                  <div className="flex items-center gap-2 text-emerald-700">
                    <FileCheck2 className="w-5 h-5" />
                    <p className="text-sm font-semibold">{borrador.archivo}</p>
                    <Button size="sm" variant="ghost" className="h-7 text-slate-500" onClick={() => { setBorrador(null); setResultado(null); }} data-testid="renov-cambiar-excel">
                      <X className="w-3.5 h-3.5 mr-1" /> Cambiar
                    </Button>
                  </div>
                  <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                    <div className="border rounded-lg p-3 bg-slate-50"><p className="text-[11px] text-slate-500">Cliente detectado</p><p className="text-sm font-semibold text-slate-800">{r.cliente || "-"}</p></div>
                    <div className="border rounded-lg p-3 bg-slate-50"><p className="text-[11px] text-slate-500">Moneda</p><p className="text-sm font-semibold text-slate-800">{r.moneda || "-"}</p></div>
                    <div className="border rounded-lg p-3 bg-slate-50"><p className="text-[11px] text-slate-500">Prima vigencia / renovación</p><p className="text-sm font-semibold text-slate-800">{fmt(r.total_vigencia)} → {fmt(r.total_renovacion)}</p></div>
                    <div className="border rounded-lg p-3 bg-slate-50">
                      <p className="text-[11px] text-slate-500">Diferencia</p>
                      <p className={`text-sm font-bold ${(r.diferencia || 0) <= 0 ? "text-emerald-600" : "text-red-600"}`}>{fmt(r.diferencia)} {(r.diferencia || 0) <= 0 ? "(ahorro)" : ""}</p>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1.5 items-center">
                    <span className="text-xs text-slate-500">Ramos detectados:</span>
                    {r.ramos_detectados.map(x => <Badge key={x} className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">{x}</Badge>)}
                    {r.tiene_licitacion && <Badge variant="outline" className="text-slate-600">Licitación ({r.num_aseguradoras_licitacion} aseguradoras)</Badge>}
                    {r.tiene_comparativo && <Badge variant="outline" className="text-slate-600">Comparativo de primas</Badge>}
                  </div>
                </div>
              )}
              {!borrador && borradoresGuardados.length > 0 && (
                <div className="space-y-2" data-testid="renov-borradores-guardados">
                  <p className="text-sm font-semibold text-slate-700">Borradores guardados</p>
                  <div className="divide-y border rounded-lg">
                    {borradoresGuardados.map(b => (
                      <div key={b.id} className="flex items-center justify-between px-3 py-2.5">
                        <div>
                          <p className="text-sm font-medium text-slate-800">{b.cliente || b.archivo || "Sin cliente"} {b.anio ? <span className="text-slate-400">· {b.anio}</span> : null}</p>
                          <p className="text-xs text-slate-400">{b.archivo} · Paso {(b.paso || 0) + 1} de {PASOS.length} · {b.guardado_por || ""} · {b.guardado_at ? new Date(b.guardado_at).toLocaleString("es-DO") : ""}</p>
                        </div>
                        <div className="flex gap-2">
                          <Button size="sm" className="h-8 gap-1 bg-emerald-600 hover:bg-emerald-700" onClick={() => retomarBorrador(b.id)} data-testid={`renov-borrador-retomar-${b.id}`}>
                            <ChevronRight className="w-3.5 h-3.5" /> Retomar
                          </Button>
                          <Button size="sm" variant="ghost" className="h-8 text-red-500 hover:text-red-600" onClick={() => eliminarBorrador(b.id)} data-testid={`renov-borrador-eliminar-${b.id}`}>
                            <Trash2 className="w-3.5 h-3.5" />
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {/* PASO 2: Datos */}
          {paso === 1 && borrador && (
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div><Label>Nombre del cliente (portada)</Label><Input value={form.cliente} onChange={e => setForm({ ...form, cliente: e.target.value })} data-testid="renov-cliente-input" /></div>
                <div><Label>Año (portada)</Label><Input value={form.anio} onChange={e => setForm({ ...form, anio: e.target.value })} data-testid="renov-anio-input" /></div>
                <div><Label>Período vigencia</Label><Input value={form.periodo_vig} onChange={e => setForm({ ...form, periodo_vig: e.target.value })} placeholder="2025 / 2026" data-testid="renov-periodovig-input" /></div>
                <div><Label>Período renovación</Label><Input value={form.periodo_ren} onChange={e => setForm({ ...form, periodo_ren: e.target.value })} placeholder="2026 / 2027" data-testid="renov-periodoren-input" /></div>
                <div><Label>Moneda</Label><Input value={form.moneda} onChange={e => setForm({ ...form, moneda: e.target.value })} placeholder="Dólares US$" data-testid="renov-moneda-input" /></div>
              </div>
              <div>
                <Label className="mb-1.5 block">Logo del cliente (opcional, portada)</Label>
                {!logo ? (
                  <div onClick={() => logoRef.current?.click()} className="border-2 border-dashed rounded-lg px-4 py-3 text-center cursor-pointer border-slate-300 hover:border-emerald-400 hover:bg-slate-50" data-testid="renov-logo-dropzone">
                    <UploadCloud className="w-5 h-5 mx-auto mb-1 text-slate-400" />
                    <p className="text-xs text-slate-500">Click para subir el logo</p>
                    <input ref={logoRef} type="file" accept="image/*" className="hidden" onChange={e => { const f = e.target.files?.[0]; if (f) setLogo(f); e.target.value = ""; }} data-testid="renov-logo-input" />
                  </div>
                ) : (
                  <div className="flex items-center gap-3 border rounded-lg px-3 py-2 bg-slate-50">
                    <img src={URL.createObjectURL(logo)} alt="Logo" className="h-9 max-w-[120px] object-contain" />
                    <span className="text-xs text-slate-600 flex-1 truncate">{logo.name}</span>
                    <button type="button" onClick={() => setLogo(null)} className="text-red-500 p-1" data-testid="renov-logo-quitar"><X className="w-4 h-4" /></button>
                  </div>
                )}
              </div>
              <div>
                <Label className="mb-1.5 block">Distribución de coaseguro (la primera es la líder)</Label>
                <div className="space-y-2">
                  {coaseguro.map((c, i) => (
                    <div key={i} className="flex gap-2 items-center">
                      <Input className="w-20" value={c.pct} onChange={e => setCoaseguro(cs => cs.map((x, j) => j === i ? { ...x, pct: e.target.value } : x))} placeholder="%" data-testid={`renov-coaseguro-pct-${i}`} />
                      <span className="text-xs text-slate-400">%</span>
                      <Input value={c.nombre} onChange={e => setCoaseguro(cs => cs.map((x, j) => j === i ? { ...x, nombre: e.target.value } : x))} placeholder={i === 0 ? "Aseguradora líder" : "Aseguradora"} data-testid={`renov-coaseguro-nombre-${i}`} />
                    </div>
                  ))}
                </div>
                <p className="text-[11px] text-slate-400 mt-1">Los logos de aseguradoras de esta diapositiva se mantienen de la plantilla; los porcentajes y nombres se actualizan.</p>
              </div>
            </div>
          )}

          {/* PASO 3: Secciones */}
          {paso === 2 && borrador && (
            <div className="space-y-3">
              <p className="text-sm text-slate-600">Marca las secciones que llevará la presentación. Los ramos no detectados en el Excel aparecen deshabilitados.</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {SECCIONES.map(s => {
                  const detectado = !s.ramo || r.ramos?.[s.key];
                  return (
                    <label key={s.key} className={`flex items-center gap-2 border rounded-lg px-3 py-2.5 cursor-pointer ${!detectado ? "opacity-40 cursor-not-allowed" : incluye[s.key] ? "border-emerald-400 bg-emerald-50" : "border-slate-200"}`} data-testid={`renov-seccion-${s.key}`}>
                      <input type="checkbox" className="accent-emerald-600 w-4 h-4" disabled={!detectado} checked={!!incluye[s.key] && detectado} onChange={e => setIncluye({ ...incluye, [s.key]: e.target.checked })} />
                      <span className="text-sm text-slate-700">{s.label}</span>
                      {s.ramo && !detectado && <span className="text-[10px] text-slate-400 ml-auto">no detectado</span>}
                    </label>
                  );
                })}
              </div>
              {incluye.siniestralidad && (
                <div className="border rounded-lg p-3 bg-slate-50 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="renov-sini-form">
                  <div><Label className="text-xs">Total siniestros</Label><Input value={sini.total} onChange={e => setSini({ ...sini, total: e.target.value })} placeholder="0.00" data-testid="renov-sini-total" /></div>
                  <div><Label className="text-xs">% Siniestralidad acumulada</Label><Input value={sini.pct} onChange={e => setSini({ ...sini, pct: e.target.value })} placeholder="0.00" data-testid="renov-sini-pct" /></div>
                  <div><Label className="text-xs">Moneda siniestralidad</Label><Input value={sini.moneda} onChange={e => setSini({ ...sini, moneda: e.target.value })} data-testid="renov-sini-moneda" /></div>
                </div>
              )}
            </div>
          )}

          {/* PASO 4: Contactos de Servicio */}
          {paso === 3 && borrador && (
            <div className="space-y-4" data-testid="renov-contactos-paso">
              <div className="flex items-center justify-between">
                <p className="text-sm text-slate-600 flex items-center gap-1.5"><Users className="w-4 h-4 text-emerald-600" /> Edita los contactos de servicio de la última diapositiva. Al buscar una persona, sus datos se traen del directorio.</p>
                <Button size="sm" variant="outline" onClick={() => setGrupos(g => [...g, { titulo: "", contactos: [{ nombre: "", posicion: "", telefono: "", movil: "", correo: "" }] }])} className="gap-1" data-testid="renov-agregar-grupo">
                  <Plus className="w-3.5 h-3.5" /> Grupo
                </Button>
              </div>
              <div className="space-y-4 max-h-[460px] overflow-y-auto pr-1">
                {grupos.map((g, gi) => (
                  <div key={gi} className="border rounded-lg p-3 space-y-2 bg-slate-50/60" data-testid={`renov-grupo-${gi}`}>
                    <div className="flex gap-2 items-center">
                      <Input className="font-semibold bg-white" value={g.titulo} placeholder="Título del grupo (ej: Reclamaciones)" onChange={e => setGrupos(gs => gs.map((x, i) => i === gi ? { ...x, titulo: e.target.value } : x))} data-testid={`renov-grupo-titulo-${gi}`} />
                      <button type="button" className="text-red-500 p-1.5 hover:bg-red-50 rounded" onClick={() => setGrupos(gs => gs.filter((_, i) => i !== gi))} data-testid={`renov-grupo-eliminar-${gi}`}>
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                    {g.contactos.map((c, ci) => (
                      <div key={ci} className="grid grid-cols-2 md:grid-cols-6 gap-1.5 items-start bg-white border rounded-md p-2">
                        <div className="md:col-span-2">
                          <ContactoSelect
                            value={c.nombre}
                            directorio={directorio}
                            onChange={v => setContacto(gi, ci, "nombre", v)}
                            onSelect={d => seleccionarContacto(gi, ci, d)}
                            testId={`renov-contacto-nombre-${gi}-${ci}`}
                          />
                          <Input className="mt-1.5" value={c.posicion} placeholder="Posición" onChange={e => setContacto(gi, ci, "posicion", e.target.value)} data-testid={`renov-contacto-posicion-${gi}-${ci}`} />
                        </div>
                        <div className="md:col-span-2">
                          <Input value={c.telefono} placeholder="Teléfono / Ext." onChange={e => setContacto(gi, ci, "telefono", e.target.value)} data-testid={`renov-contacto-telefono-${gi}-${ci}`} />
                          <Input className="mt-1.5" value={c.movil} placeholder="Móvil / Flota" onChange={e => setContacto(gi, ci, "movil", e.target.value)} data-testid={`renov-contacto-movil-${gi}-${ci}`} />
                        </div>
                        <div className="md:col-span-2 flex gap-1.5 items-start">
                          <Input value={c.correo} placeholder="Correo" onChange={e => setContacto(gi, ci, "correo", e.target.value)} data-testid={`renov-contacto-correo-${gi}-${ci}`} />
                          <button type="button" className="text-red-400 p-1.5 hover:bg-red-50 rounded shrink-0" onClick={() => setGrupos(gs => gs.map((x, i) => i === gi ? { ...x, contactos: x.contactos.filter((_, j) => j !== ci) } : x))} data-testid={`renov-contacto-eliminar-${gi}-${ci}`}>
                            <X className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    ))}
                    <Button size="sm" variant="ghost" className="gap-1 text-emerald-700 h-7" onClick={() => setGrupos(gs => gs.map((x, i) => i === gi ? { ...x, contactos: [...x.contactos, { nombre: "", posicion: "", telefono: "", movil: "", correo: "" }] } : x))} data-testid={`renov-agregar-contacto-${gi}`}>
                      <Plus className="w-3.5 h-3.5" /> Agregar contacto
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* PASO 5: Endosos aclaratorios */}
          {paso === 4 && borrador && (
            <div className="space-y-4" data-testid="renov-endosos-paso">
              <p className="text-sm text-slate-600">Personaliza los endosos aclaratorios de cada póliza. Cada endoso genera su propia diapositiva — puedes agregar cuantos necesites, sin límite.</p>
              <div className="space-y-4 max-h-[480px] overflow-y-auto pr-1">
                {SECCIONES_ENDOSOS.filter(s => r.ramos?.[s.key]).map(s => (
                  <div key={s.key} className="border rounded-lg p-3 space-y-2 bg-slate-50/60" data-testid={`renov-endosos-${s.key}`}>
                    <div className="flex items-center justify-between">
                      <p className="text-sm font-semibold text-slate-700">{s.label} <span className="text-xs font-normal text-slate-400">({endosos[s.key].length} endoso{endosos[s.key].length !== 1 ? "s" : ""} = {endosos[s.key].length} diapositiva{endosos[s.key].length !== 1 ? "s" : ""})</span></p>
                      <Button size="sm" variant="outline" className="gap-1 h-7" onClick={() => setEndosos(es => ({ ...es, [s.key]: [...es[s.key], { titulo: "", contenido: "" }] }))} data-testid={`renov-agregar-endoso-${s.key}`}>
                        <Plus className="w-3.5 h-3.5" /> Endoso
                      </Button>
                    </div>
                    {endosos[s.key].length === 0 && <p className="text-xs text-slate-400">Sin endosos — no se incluirán diapositivas de endosos para esta póliza.</p>}
                    {endosos[s.key].map((e, ei) => (
                      <div key={ei} className="bg-white border rounded-md p-2 space-y-1.5">
                        <div className="flex gap-2 items-center">
                          <Input className="font-medium" value={e.titulo} placeholder="Título del endoso (ej: RC Valet Parking:)" onChange={ev => setEndosos(es => ({ ...es, [s.key]: es[s.key].map((x, j) => j === ei ? { ...x, titulo: ev.target.value } : x) }))} data-testid={`renov-endoso-titulo-${s.key}-${ei}`} />
                          <button type="button" className="text-red-500 p-1.5 hover:bg-red-50 rounded shrink-0" onClick={() => setEndosos(es => ({ ...es, [s.key]: es[s.key].filter((_, j) => j !== ei) }))} data-testid={`renov-endoso-eliminar-${s.key}-${ei}`}>
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                        <Textarea rows={4} value={e.contenido} placeholder="Contenido del endoso..." onChange={ev => setEndosos(es => ({ ...es, [s.key]: es[s.key].map((x, j) => j === ei ? { ...x, contenido: ev.target.value } : x) }))} data-testid={`renov-endoso-contenido-${s.key}-${ei}`} />
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* PASO 6: Textos IA */}
          {paso === 5 && borrador && (
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <p className="text-sm text-slate-600">La IA redacta los textos narrativos con los datos reales del Excel; edítalos libremente.</p>
                <Button size="sm" onClick={generarTextosIA} disabled={generandoTextos} className="gap-1.5 bg-emerald-600 hover:bg-emerald-700" data-testid="renov-textos-ia-btn">
                  {generandoTextos ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} Proponer con IA
                </Button>
              </div>
              <div><Label>¿Qué hemos hecho?</Label><Textarea rows={4} value={textos.que_hemos_hecho} onChange={e => setTextos({ ...textos, que_hemos_hecho: e.target.value })} data-testid="renov-texto-hecho" /></div>
              <div><Label>¿Qué hemos logrado?</Label><Textarea rows={4} value={textos.que_hemos_logrado} onChange={e => setTextos({ ...textos, que_hemos_logrado: e.target.value })} data-testid="renov-texto-logrado" /></div>
              <div><Label>Observaciones del cuadro de licitación</Label><Textarea rows={3} value={textos.observaciones} onChange={e => setTextos({ ...textos, observaciones: e.target.value })} data-testid="renov-texto-observaciones" /></div>
              <p className="text-[11px] text-slate-400">Si dejas un campo vacío, se mantiene el texto de la plantilla (u observaciones del Excel).</p>
            </div>
          )}

          {/* PASO 7: Generar */}
          {paso === 6 && borrador && (
            <div className="space-y-4">
              <div className="border rounded-lg p-4 bg-slate-50 text-sm text-slate-700 space-y-1">
                <p><span className="font-semibold">{form.cliente}</span> · {form.anio} · {form.moneda}</p>
                <p className="text-xs text-slate-500">Períodos: {form.periodo_vig} → {form.periodo_ren}</p>
                <div className="flex flex-wrap gap-1 pt-1">
                  {SECCIONES.filter(s => incluye[s.key] && (!s.ramo || r.ramos?.[s.key])).map(s => <Badge key={s.key} variant="outline" className="text-emerald-700 border-emerald-300">{s.label}</Badge>)}
                </div>
              </div>
              <Button onClick={generarPPT} disabled={generando || regenerando} className="w-full bg-emerald-600 hover:bg-emerald-700 gap-2" data-testid="renov-generar-btn">
                {generando ? <><Loader2 className="w-4 h-4 animate-spin" /> Generando presentación...</> : <><Sparkles className="w-4 h-4" /> {resultado ? "Generar nueva presentación" : "Generar presentación de renovación"}</>}
              </Button>
              {resultado && (
                <Button onClick={() => regenerarPPT()} disabled={generando || regenerando} variant="outline" className="w-full gap-2 border-emerald-400 text-emerald-700 hover:bg-emerald-50" data-testid="renov-regenerar-btn">
                  {regenerando ? <><Loader2 className="w-4 h-4 animate-spin" /> Regenerando con los cambios...</> : <>Regenerar esta presentación con los cambios actuales (mismo archivo)</>}
                </Button>
              )}
              {resultado && (
                <div className="space-y-3" data-testid="renov-resultado">
                  <div className="border border-emerald-300 bg-emerald-50 rounded-lg p-4 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <CheckCircle2 className="w-5 h-5 text-emerald-600" />
                      <div>
                        <p className="text-sm font-semibold text-slate-800">Presentación lista</p>
                        <p className="text-xs text-slate-500">{resultado.cliente} · {resultado.anio}</p>
                      </div>
                    </div>
                    <Button size="sm" className="gap-1.5 bg-emerald-600 hover:bg-emerald-700" onClick={() => descargar(resultado.id, `Presentacion Renovacion ${resultado.cliente} ${resultado.anio}.pptx`)} data-testid="renov-descargar-btn">
                      <Download className="w-4 h-4" /> Descargar PPTX
                    </Button>
                  </div>
                  {cargandoPreviews && (
                    <p className="text-xs text-slate-500 flex items-center gap-1.5"><Loader2 className="w-3.5 h-3.5 animate-spin" /> Cargando vistas previas de las diapositivas...</p>
                  )}
                  {previews.length > 0 && (
                    <div data-testid="renov-previews">
                      <p className="text-xs font-semibold text-slate-600 flex items-center gap-1 mb-1.5"><Eye className="w-3.5 h-3.5 text-emerald-600" /> Vista previa ({previews.length} diapositivas — click para ampliar)</p>
                      <div className="grid grid-cols-4 md:grid-cols-6 gap-2 max-h-72 overflow-y-auto pr-1">
                        {previews.map((u, i) => (
                          <button key={i} type="button" onClick={() => setPreviewIdx(i)} className="relative border rounded-md overflow-hidden hover:ring-2 hover:ring-emerald-500 transition-shadow" data-testid={`renov-preview-thumb-${i}`}>
                            <img src={u} alt={`Diapositiva ${i + 1}`} className="w-full h-auto" />
                            <span className="absolute bottom-0.5 right-1 text-[9px] bg-slate-900/70 text-white rounded px-1">{i + 1}</span>
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Navegación */}
          {borrador && (
            <div className="flex justify-between items-center gap-2 pt-2 border-t">
              <Button variant="outline" size="sm" disabled={paso === 0} onClick={() => setPaso(paso - 1)} className="gap-1" data-testid="renov-atras-btn">
                <ChevronLeft className="w-4 h-4" /> Anterior
              </Button>
              <Button variant="outline" size="sm" disabled={guardandoBorrador} onClick={guardarBorrador} className="gap-1.5 border-slate-300 text-slate-600" data-testid="renov-guardar-borrador-btn">
                {guardandoBorrador ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileCheck2 className="w-3.5 h-3.5" />} Guardar borrador
              </Button>
              {paso < PASOS.length - 1 && (
                <Button size="sm" onClick={() => setPaso(paso + 1)} className="gap-1 bg-emerald-600 hover:bg-emerald-700" data-testid="renov-siguiente-btn">
                  Siguiente <ChevronRight className="w-4 h-4" />
                </Button>
              )}
            </div>
          )}
        </CardContent>
      </Card>

      {/* Historial */}
      <Card>
        <CardHeader className="pb-3"><CardTitle className="text-base">Historial de presentaciones de renovación</CardTitle></CardHeader>
        <CardContent>
          {historial.length === 0 ? (
            <p className="text-sm text-slate-400 py-3 text-center">Aún no hay presentaciones de renovación generadas</p>
          ) : (
            <div className="divide-y">
              {historial.map(h => (
                <div key={h.id} className="flex items-center justify-between py-2.5">
                  <div>
                    <p className="text-sm font-medium text-slate-800">{h.cliente} <span className="text-slate-400">· {h.anio}</span></p>
                    <p className="text-xs text-slate-400">{h.usuario_nombre} · {new Date(h.created_at).toLocaleString("es-DO")} · {h.archivo_excel}</p>
                  </div>
                  <div className="flex gap-2">
                    {h.num_previews > 0 && (
                      <Button size="sm" variant="outline" className="gap-1 h-8" onClick={async () => { await loadPreviews(h.id, h.num_previews); setPreviewIdx(0); }} data-testid={`renov-hist-ver-${h.id}`}>
                        <Eye className="w-3.5 h-3.5" /> Ver
                      </Button>
                    )}
                    <Button size="sm" variant="outline" className="gap-1 h-8" onClick={() => descargar(h.id, `Presentacion Renovacion ${h.cliente} ${h.anio}.pptx`)} data-testid={`renov-hist-descargar-${h.id}`}>
                      <Download className="w-3.5 h-3.5" /> PPTX
                    </Button>
                    <Button size="sm" variant="ghost" className="h-8 text-red-500 hover:text-red-600" onClick={() => eliminar(h.id)} data-testid={`renov-hist-eliminar-${h.id}`}>
                      <Trash2 className="w-3.5 h-3.5" />
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      {/* Modal de vista previa ampliada */}
      <Dialog open={previewIdx !== null} onOpenChange={(o) => { if (!o) setPreviewIdx(null); }}>
        <DialogContent className="max-w-5xl p-4" data-testid="renov-preview-modal">
          <DialogTitle className="text-sm text-slate-700 flex items-center justify-between pr-6">
            <span>Vista previa · Diapositiva {previewIdx !== null ? previewIdx + 1 : ""} de {previews.length}</span>
            {resultado?.id && (
              <Button size="sm" variant="outline" disabled={regenerando} className="gap-1.5 h-7 border-emerald-400 text-emerald-700 hover:bg-emerald-50" onClick={() => regenerarPPT(previewIdx)} data-testid="renov-regenerar-slide-btn">
                {regenerando ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />} Regenerar diapositiva
              </Button>
            )}
          </DialogTitle>
          {previewIdx !== null && previews[previewIdx] && (
            <div className="relative">
              <img src={previews[previewIdx]} alt="Vista previa" className="w-full rounded-md border" />
              {previewIdx > 0 && (
                <button type="button" onClick={() => setPreviewIdx(previewIdx - 1)} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 border rounded-full p-1.5 shadow hover:bg-white" data-testid="renov-preview-prev">
                  <ChevronLeft className="w-5 h-5 text-slate-700" />
                </button>
              )}
              {previewIdx < previews.length - 1 && (
                <button type="button" onClick={() => setPreviewIdx(previewIdx + 1)} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 border rounded-full p-1.5 shadow hover:bg-white" data-testid="renov-preview-next">
                  <ChevronRight className="w-5 h-5 text-slate-700" />
                </button>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
